import { useMemo, useState } from "react";
import VirtualizedTable from "../components/VirtualizeTable"; // ajuste o caminho conforme seu projeto
import ProfessorDelete from "./ProfessorDelete";
import { formatPhone } from "../helpers/format";
import { IconEdit, IconTrash } from "@tabler/icons-react";
import { MRT_ColumnDef } from "material-react-table";
import { useNavigate } from "react-router";

const ProfessorTableComponent = ({
  data,
  refetch,
}: {
  data: Array<{
    id: string;
    fullName: string;
    email: string;
    phone: string;
    document?: string;
    birthDate?: string;
    nickName?: string;
    status?: string;
  }>;
  refetch: () => void;
}) => {
  const navigate = useNavigate();
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [id, setId] = useState("");

  const columns = useMemo<MRT_ColumnDef<any>[]>(() => {
    return [
      {
        accessorKey: "fullName",
        header: "Nome",
      },
      {
        accessorKey: "email",
        header: "E-mail",
      },
      {
        accessorKey: "phone",
        header: "Telefone",
        Cell: ({ cell }: any) => formatPhone(cell.getValue()),
      },
      {
        accessorKey: "status",
        header: "Status",
        muiTableHeadCellProps: { align: "center", sx: { textAlign: "center" } },
        muiTableBodyCellProps: { align: "center", sx: { textAlign: "center" } },
        enableSorting: false,
        enableColumnActions: false,
        Cell: ({ cell }: any) => {
          const status = cell.getValue();

          const getStatusStyle = () => {
            if (status === "REGISTERED") {
              return { label: "Registrado", color: "#2e7d32" }; // verde
            }
            if (status === "PENDING") {
              return { label: "Pendente", color: "#ed6c02" }; // laranja
            }
            return { label: "Bloqueado", color: "#d32f2f" }; // vermelho
          };

          const { label, color } = getStatusStyle();

          return (
            <div
              style={{
                padding: "4px 12px",
                borderRadius: "12px",
                backgroundColor: color,
                color: "#fff",
                fontWeight: 600,
                fontSize: "0.75rem",
                textAlign: "center",
                display: "inline-block",
                minWidth: "150px",
              }}
            >
              {label}
            </div>
          );
        },
      },
      {
        id: "edit",
        header: "Editar",
        size: 50,
        Cell: ({ row }: any) => (
          <IconEdit
            onClick={() => navigate(`/professors-details/${row.original.id}`)}
            style={{ cursor: "pointer", color: "#FFF" }}
          />
        ),
        muiTableHeadCellProps: { align: "center", sx: { textAlign: "center" } },
        muiTableBodyCellProps: { align: "center", sx: { textAlign: "center" } },
        enableSorting: false,
        enableColumnActions: false,
      },
      {
        id: "delete",
        header: "Excluir",
        size: 50,
        Cell: ({ row }: any) => (
          <IconTrash
            onClick={() => {
              setId(row.original.id);
              setDeleteAlert(true);
            }}
            style={{ cursor: "pointer", color: "#d32f2f" }}
          />
        ),
        muiTableHeadCellProps: { align: "center", sx: { textAlign: "center" } },
        muiTableBodyCellProps: { align: "center", sx: { textAlign: "center" } },
        enableSorting: false,
        enableColumnActions: false,
      },
    ];
  }, []);

  return (
    <>
      <VirtualizedTable
        data={data}
        columns={columns}
        fetchNextPage={() => Promise.resolve()}
        isLoading={false}
      />

      <ProfessorDelete
        open={deleteAlert}
        onClose={() => setDeleteAlert(false)}
        id={id}
        refetch={refetch}
      />
    </>
  );
};

export default ProfessorTableComponent;
